module.exports = __webpack_public_path__ + "static/media/Event_language.d7bd1b47.gif";